import CreditCardModal from './CreditCardModal'
import {sendCardToStripe} from '../../../../lib/stripeUtils'

const CreditCardModalController = () => <CreditCardModal sendCardToStripe={sendCardToStripe} />

export default CreditCardModalController
